<!--
 * @Author: wanghui@ykccn.com
 * @Date: 2023-02-13
 * @Description: 营销管理/平台营销工具/平台卡券活动/领取记录
-->
<template>
  <scroll-layout>
    <template #header>
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
      <ykc-search ref="YkcSearch" :data="searchItems" @click="handleSearchConfirm" />
    </template>
    <ykc-table
      ref="YkcTable"
      :data="tableData"
      :columns="tableColumns"
      :operateButtons="tableOperateButtons">
      <template #title>
        <div>
          <span class="ykc-table-header-title">{{ tableTitle }}</span>
        </div>
      </template>
      <template #headerButtons>
        <div class="table-header-button">
          <ykc-button type="plain" @click="exportBlob">导出</ykc-button>
        </div>
      </template>
      <ykc-pagination
        slot="pagination"
        ref="YkcPagination"
        :total="total"
        :current-page.sync="currentPage"
        @current-change="handlePaginationCurrentChange"
        :page-size.sync="pageSize"
        @size-change="handlePaginationSizeChange" />
    </ykc-table>
  </scroll-layout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { couponActivity } from '@/service/apis';
  import { offlineExport } from '@/utils'; // 新增/编辑组件

  export default {
    name: 'chargeTaskPickUpRecord',
    components: {},
    computed: {
      ...mapGetters([]),
    },
    data() {
      return {
        count: 0,
        tableOperateButtons: [],
        activityId: '',
        activityType: '',
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        /**
         * 查询数据
         */
        searchItems: [],
        tableData: [],

        tableColumns: [
          { label: '参与用户', prop: 'phone' },
          { label: '参与时间', prop: 'joinTime' },
          { label: '当前累计度/次', prop: 'total' },
          { label: '已发放卡券信息', prop: 'cardCoupon' },
          { label: '活动名称', prop: 'activityName' },
          { label: '活动类型', prop: 'activityType' },
          { label: '最近一次充电站点', prop: 'lastStationName' },
          { label: '省份', prop: 'provinceName' },
          { label: '城市', prop: 'cityName' },
          { label: '最近一次充电开始时间', prop: 'lastChargeTime' },
        ],
        tableTitle: '参与记录',
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
    },
    created() {
      this.activityId = this.$route.query.activityId || '';
      this.activityType = this.$route.query.activityType || '';

      this.searchItems = [
        {
          comName: 'YkcDatePicker',
          type: 'daterange',
          format: 'yyyy-MM-dd',
          key: 'collectioTime',
          label: '参与时间',
        },
        {
          comName: 'YkcInput',
          key: 'phone',
          label: '参与用户',
          placeholder: '请输入领取用户',
        },
      ];

      this.getData();
    },
    methods: {
      /**
       * 点击查询
       * @param form
       */
      handleSearchConfirm(form) {
        this.currentPage = 1;
        const search = JSON.parse(JSON.stringify(form));
        if (search.collectioTime && search.collectioTime.length === 2) {
          [search.beginTime, search.endTime] = search.collectioTime;
        }

        // delete search.receiveTimeStart;
        // delete search.receiveTimeEnd;
        this.searchParams = search || {};
        this.getData();
      },
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
        console.log('列表按钮点击事件', button, event);
      },
      /**
       * 导出
       */
      exportBlob() {
        offlineExport({
          downloadType: 'marketing_export',
          jsonNode: {
            downloadKey: 'offline_task_join_export',
            activityId: this.activityId || '',
            ...this.searchParams,
          },
        });
      },

      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.currentPage = current;
        this.getData();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.currentPage = 1;
        this.pageSize = size;
        this.getData();
      },

      /**
       * @desc 获取数据
       * */
      getData() {
        const reqData = {
          ...(this.searchParams || {}),
          current: this.currentPage,
          size: this.pageSize,
        };
        reqData.activityId = this.activityId || '';
        couponActivity.chargeTaskReceiveRecord(reqData).then(res => {
          this.tableData = res.records || [];
          this.total = res.total;
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-table-header-subtitle {
    font-size: 12px;
    margin-left: 28px;
  }
</style>
